import type { Message, StreamingMessage } from '../types';
import type { PendingFile } from './FilePreview';
import { MessageList } from './MessageList';
import { InputArea } from './InputArea';
import { StatusMessage } from './StatusMessage';

interface ChatViewProps {
  messages: Message[];
  isTyping: boolean;
  statusMessage: string | null;
  onSend: (message: string) => void;
  isConnected: boolean;
  pendingFiles: PendingFile[];
  onFileRemove: (id: string) => void;
  onFilesSelected: (files: File[]) => void;
  onTabChange?: (tab: 'you' | 'files') => void;
  streamingMessage?: StreamingMessage | null;
}

export function ChatView({
  messages,
  isTyping,
  statusMessage,
  onSend,
  isConnected,
  pendingFiles,
  onFileRemove,
  onFilesSelected,
  onTabChange,
  streamingMessage,
}: ChatViewProps) {
  return (
    <div className="flex flex-col h-full">
      <MessageList
        messages={messages}
        isTyping={isTyping}
        onTabChange={onTabChange}
        streamingMessage={streamingMessage}
      />
      <StatusMessage message={statusMessage} />
      <InputArea
        onSend={onSend}
        isConnected={isConnected}
        pendingFiles={pendingFiles}
        onFileRemove={onFileRemove}
        onFilesSelected={onFilesSelected}
      />
    </div>
  );
}
